import React, { useState } from "react";
import { useEffect } from "react";
import {
  adminDeleteUser,
  adminEditUser,
  adminAddUser,
  getAdminUsersDetails,
} from "../../redux/adminSlice";
import { loginUser } from "../../redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import EditUserDialog from "./EditUserDialog";
import ConfirmDialog from "../../Utils/ConfirmDialog";

const UserDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.admin.userDetails);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editedUser, setEditedUser] = useState(null);
  const [id, setId] = useState("");
  const [deleteUser, setDeleteUser] = useState(null);
  const [showCreateAccount, setShowCreateAccount]= useState(false);
  const [newAccount, setNewAccount] = useState({password:randomPassword()});

  useEffect(() => {
    dispatch(getAdminUsersDetails());
  }, []);

  const handleDelete = () => {
    if (deleteUser===null) return;
    const id = deleteUser.id;
    setDeleteUser(null);
    dispatch(adminDeleteUser(id))
      .then(() => {
        dispatch(getAdminUsersDetails());
        toast.success("User deleted successfully!");
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      });
  };

  const handleEdit = (user) => {
    setId(user);
    if (user) {
      setEditedUser({
        id: user.id,
        username: user.username,
        email: user.email,
        number: user.number,
        isAdmin: user.isAdmin,
        istest: user.istest,
        total_guests : user.total_guests,
        newPassword: "",
      });
      setOpenEditDialog(true);
    } else {
      console.error("User not found with id:", id);
    }
  };

  const handleSave = (editedData) => {
    dispatch(adminEditUser({ editedData, id }))
      .then(() => {
        dispatch(getAdminUsersDetails());
        toast.success("User details updated successfully!");
        setOpenEditDialog(false);
      })
      .catch((error) => {
        console.error("Error updating user details:", error);
      });
  };

  const prettyAmount = (n) => {
    if (n===undefined || n===null || n==="") {
      return "";
    }
    var c = Number(n);
    if (!isNaN(c)) {
      return (c/100).toFixed(2);
    }
    return n;
  }

  const handleBecome = async (editedData) => {
    const data={
      email: editedData.email,
      password: "become"
    };
    const res = await dispatch(loginUser(data));
    if (res.meta.requestStatus === "fulfilled") {
      toast.success("Become "+editedData.email);
      res?.payload?.isAdmin ? navigate("/admin") : navigate("/dashboard");
    } else {
      toast.error("Become user failed");
    }
  }

  const handleCreateAccount = async () => {
    if (!(newAccount?.name?.length>=1)) {
      return toast.error("name required");
    }
    if (!(newAccount?.email?.length>=3)) {
      return toast.error("email required");
    }
    if (!(newAccount?.number?.length>=1)) {
      return toast.error("phone number required");
    }
    if (!(newAccount?.password?.length>7)) {
      return toast.error("longer than 8 letter password required");
    }
    await dispatch(adminAddUser(newAccount));
    setShowCreateAccount(false);
    setNewAccount({password:randomPassword()});
    await dispatch(getAdminUsersDetails());
    toast.success("Account created");
  }

  const handleEditQuestions = async ( editedData ) => {
    navigate("/admin/user/" + editedData.id + "/questions")
  }
  const handleEditReports = async ( editedData ) => {
    navigate("/admin/user/" + editedData.id + "/reports")
  }

  return (
    <div className="col-md-12 user-details">
      <div>
        <button className="btn" onClick={()=>setShowCreateAccount(true)}>
          Create Account
        </button>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Full name</th>
            <th scope="col">Contact number</th>
            <th scope="col">Email address</th>
            <th scope="col">Package</th>
            <th scope="col">Amount</th>
            <th scope="col">Date</th>
            <th scope="col">Custom PDF</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {userDetails.length > 0 ? (
            userDetails?.map((user, index) => (
              <tr>
                <td>{user.username}</td>
                <td>{user.number}</td>
                <td>{user.email}</td>
                <td>{user.package}</td>
                <td>{prettyAmount(user.amount)}</td>
                <td>{formatDate(user.date)}</td>
                <td style={{textAlign:'center'}}>{user.upload===true ? '✓' : ''}</td>
                <td>
                  <button className="px-1 m-1" onClick={() => handleEdit(user)}>
                    Edit
                  </button>
                  <button className="px-1 m-1" onClick={() => handleEditReports(user)}>
                    Reports
                  </button>
                  <button className="px-1 m-1" onClick={() => handleEditQuestions(user)}>
                    Questions
                  </button>
                  <button className="px-1 m-1" onClick={() => setDeleteUser(user)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <h4>No Data To Show</h4>
          )}
          {openEditDialog && editedUser && (
            <EditUserDialog
              open={openEditDialog}
              onClose={() => setOpenEditDialog(false)}
              onSave={handleSave}
              onBecome={handleBecome}
              onEditQuestions={handleEditQuestions}
              onEditReports={handleEditReports}
              user={editedUser}
            />
          )}
        </tbody>
      </table>

      <Dialog
        open={showCreateAccount}
        onClose={()=>setShowCreateAccount(false)}
        aria-labelledby="create-dialog-title"
        aria-describedby="create-dialog-description"        
      >
        <DialogTitle id="create-dialog-title">
          Create account
        </DialogTitle>
        <DialogContent>
        <TextField
            label="Full Name"
            name="newName"
            value={newAccount?.name}
            onChange={(e)=> setNewAccount((p)=>{return {...p, "name":e.target.value}})}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Email Address"
            name="newEmail"
            value={newAccount?.email}
            onChange={(e)=> setNewAccount((p)=>{return {...p, "email":e.target.value}})}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Contact Number"
            name="newNumber"
            value={newAccount?.number}
            onChange={(e)=> setNewAccount((p)=>{return {...p, "number":e.target.value}})}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Password"
            name="newPassword"
            value={newAccount?.password}
            onChange={(e)=> setNewAccount((p)=>{return {...p, "password":e.target.value}})}
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setShowCreateAccount(false)} autoFocus>Cancel</Button>
          <Button onClick={handleCreateAccount}>Create</Button>
        </DialogActions>
      </Dialog>

      <ConfirmDialog
        open = {deleteUser!==null}
        onClose = {()=>setDeleteUser(null)}
        title = {<>Delete account for {deleteUser?.username}</>}
        text = {<>Confirm delete of {deleteUser?.username} : {deleteUser?.email}</>}
        okText = "Delete"
        onOK = {handleDelete}
      />
    </div>
  );
};

function formatDate(date) {
  if (!date) return "";
  try {
    return new Intl.DateTimeFormat('en-GB', {
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(new Date(date));
  } catch (e) {}
  return ""
}

function randomPassword() {
  return Math.round(Math.random()*1e16).toString(36);
}

export default UserDetails;
